var _regeneratorRuntime = require("/home/richard/status/status-teller-network/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/richard/status/status-teller-network/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var ethUtils = require('ethereumjs-util');

var EthCrypto = require('eth-crypto');

var web3Utils = require('web3-utils');

var relay_prefix = "rlx:";

function toUint256_noPrefix(int) {
  return removeHexPrefix(ethUtils.bufferToHex(ethUtils.setLengthLeft(int, 32)));
}

function removeHexPrefix(hex) {
  return hex.replace(/^0x/, '');
}

var zeroPad = "0000000000000000000000000000000000000000000000000000000000000000";

function padTo64(hex) {
  if (hex.length < 64) {
    hex = (zeroPad + hex).slice(-64);
  }

  return hex;
}

function bytesToHex_noPrefix(bytes) {
  var hex = removeHexPrefix(web3Utils.toHex(bytes));

  if (hex.length % 2 != 0) {
    hex = "0" + hex;
  }

  return hex;
}

module.exports = {
  register_new_relay: function () {
    var _register_new_relay = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(relayHub, stake, delay, txFee, url, account) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return relayHub.stake(account, delay, {
                from: account,
                value: stake
              });

            case 2:
              _context.next = 4;
              return relayHub.registerRelay(txFee, url, {
                from: account
              });

            case 4:
              return _context.abrupt("return", _context.sent);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function register_new_relay(_x, _x2, _x3, _x4, _x5, _x6) {
      return _register_new_relay.apply(this, arguments);
    }

    return register_new_relay;
  }(),
  getTransactionHash: function getTransactionHash(from, to, tx, txfee, gas_price, gas_limit, nonce, relay_hub_address, relay_address) {
    var txhstr = bytesToHex_noPrefix(tx);
    var dataToHash = Buffer.from(relay_prefix).toString("hex") + removeHexPrefix(from) + removeHexPrefix(to) + txhstr + toUint256_noPrefix(parseInt(txfee)) + toUint256_noPrefix(parseInt(gas_price)) + toUint256_noPrefix(parseInt(gas_limit)) + toUint256_noPrefix(parseInt(nonce)) + removeHexPrefix(relay_hub_address) + removeHexPrefix(relay_address);
    return web3Utils.sha3('0x' + dataToHash);
  },
  getTransactionSignature: function () {
    var _getTransactionSignature = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(web3, account, hash) {
      var sig_, signature, sig;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return new Promise(function (resolve, reject) {
                try {
                  web3.eth.personal.sign(hash, account, function (err, res) {
                    if (err) reject(err);else resolve(res);
                  });
                } catch (e) {
                  reject(e);
                }
              });

            case 3:
              sig_ = _context2.sent;
              _context2.next = 11;
              break;

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              _context2.next = 10;
              return new Promise(function (resolve, reject) {
                web3.eth.sign(hash, account, function (err, res) {
                  if (err) reject(err);else resolve(res);
                });
              });

            case 10:
              sig_ = _context2.sent;

            case 11:
              signature = ethUtils.fromRpcSig(sig_);
              sig = web3Utils.bytesToHex(signature.r) + removeHexPrefix(web3Utils.bytesToHex(signature.s)) + removeHexPrefix(web3Utils.toHex(signature.v));
              return _context2.abrupt("return", sig);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));

    function getTransactionSignature(_x7, _x8, _x9) {
      return _getTransactionSignature.apply(this, arguments);
    }

    return getTransactionSignature;
  }(),
  getTransactionSignatureWithKey: function getTransactionSignatureWithKey(privKey, hash) {
    var withPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var signed;

    if (withPrefix) {
      var msg = Buffer.concat([Buffer.from("\x19Ethereum Signed Message:\n32"), Buffer.from(removeHexPrefix(hash), "hex")]);
      signed = web3Utils.sha3("0x" + msg.toString('hex'));
    } else signed = hash;

    var keyHex = "0x" + Buffer.from(privKey).toString('hex');
    var sig_ = EthCrypto.sign(keyHex, signed);
    var signature = ethUtils.fromRpcSig(sig_);
    var sig = web3Utils.bytesToHex(signature.r) + removeHexPrefix(web3Utils.bytesToHex(signature.s)) + removeHexPrefix(web3Utils.toHex(signature.v));
    return sig;
  },
  getEcRecoverMeta: function getEcRecoverMeta(message, signature) {
    if (typeof signature === 'string') {
      var r = this.parseHexString(signature.substr(2, 65));
      var s = this.parseHexString(signature.substr(66, 65));
      var v = this.parseHexString(signature.substr(130, 2));
      signature = {
        v: v,
        r: r,
        s: s
      };
    }

    var msg = Buffer.concat([Buffer.from("\x19Ethereum Signed Message:\n32"), Buffer.from(removeHexPrefix(message), "hex")]);
    var signed = web3Utils.sha3("0x" + msg.toString('hex'));
    var buf_signed = Buffer.from(removeHexPrefix(signed), "hex");
    var signer = ethUtils.bufferToHex(ethUtils.pubToAddress(ethUtils.ecrecover(buf_signed, signature.v, signature.r, signature.s)));
    return signer;
  },
  parseHexString: function parseHexString(str) {
    var result = [];

    while (str.length >= 2) {
      result.push(parseInt(str.substring(0, 2), 16));
      str = str.substring(2, str.length);
    }

    return result;
  },
  removeHexPrefix: removeHexPrefix,
  padTo64: padTo64
};